import { SELECT_ACCOUNT_TYPES, SelectAccountSubmitAction } from './SelectAccount.types';

export const onSelectAccountSubmit = (selectedInstagramAccounts: {}, selectedFacebookPages: {}): SelectAccountSubmitAction => ({
  type: SELECT_ACCOUNT_TYPES.SUBMIT,
  payload: {
    selectedInstagramAccounts,
    selectedFacebookPages,
  },
});
